var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_177_93",
    "data-name": "Componente 177 \\u2013 93",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.087,
    height: 12.087,
    viewBox: "0 0 12.087 12.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1095",
    "data-name": "Caminho 1095",
    d: "M5.686,12.4h4.7V11.058h-4.7Zm0-2.686H12.4V8.372H5.686Zm0-2.686H12.4V5.686H5.686ZM4.343,15.087A1.348,1.348,0,0,1,3,13.744v-9.4A1.347,1.347,0,0,1,4.343,3h9.4a1.346,1.346,0,0,1,1.343,1.343v9.4a1.347,1.347,0,0,1-1.343,1.343Zm0-1.343h9.4v-9.4h-9.4Zm0-9.4v0Z",
    transform: "translate(-3 -3)",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.03391098d5a2a0fd827390c59bac93d5.svg";
export { ForwardRef as ReactComponent };